import { Box, Button, TextField, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import useChangePasswordController from "./controller";
import { TEXT_TITLE_COLOR } from "../../constants/colors";
import ConfirmDialog from "../../components/ConfirmDialog";



const ChangePasswordView = () => {
    const { t } = useTranslation('global');

    const controller = useChangePasswordController()

    return <Box>
        <Typography variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>{t('Change password')}</Typography>
        <Box mt={5}>
            <form onSubmit={(e) => controller.handleOpenConfirmForm(e)}>
                <Typography>{t('Old password')}</Typography>
                <TextField placeholder={t('Enter old password') ?? ''} fullWidth sx={{ maxWidth: 350 }} margin="normal" required inputRef={controller.oldPassword} />
                <Typography>{t('New password')}</Typography>
                <TextField type="password" placeholder={t("Enter new password") ?? ''} fullWidth sx={{ maxWidth: 350 }} margin="normal" required inputRef={controller.password} />
                <Typography>{t('Confirm new password')}</Typography>
                <TextField type="password" placeholder={t("Enter confirm new password") ?? ''} fullWidth sx={{ maxWidth: 350 }} margin="normal" required inputRef={controller.confirmPassword} />
                {controller.errorMessage && <Typography color='error'>{controller.errorMessage}</Typography>}
                <Box mt={2}>
                    <Button type="submit" variant="contained" sx={{ textTransform: 'none' }}>{t('Change password')}</Button>
                </Box>
            </form>
        </Box>
        <ConfirmDialog
            open={controller.openConfirm}
            title="Do you want to Change this password ?"
            loading={controller.loadingConfirm}
            onCancel={controller.handleCloseConfirmForm}
            onConfirm={() => controller.handleChangePassword()}
        />
    </Box>
}
export default ChangePasswordView;